import React from 'react';
import ErrorPage from 'next/error';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { getPosts, getCategoriess } from '../utils/api/wordpress-api';
import ArticlesSubHeader from '../components/Articles/SubHeader';
import ArticlesMain from '../components/Articles/Main';
import BlogSEO from '../components/SEO/ForBlog';
import LoadShareloWidget from '../components/ShareloWidget';

export const checkLocaleAllowed = (locale) => {
  const notAllowedLocales = ['ru', 'tw'];
  if (notAllowedLocales.includes(locale)) {
    return false;
  }
  return true;
};

interface Props {
  posts: any;
  preview: boolean;
  categories: any[];
  pageContext: any;
}

function Index({ posts, preview: _preview, categories, pageContext }: Props) {
  const { t } = useTranslation(['blog', 'common']);
  const router = useRouter();
  const { locale } = router;
  const edges = posts?.edges || [];

  if (!checkLocaleAllowed(locale)) {
    return <ErrorPage statusCode={404} />;
  }

  return (
    <>
      <BlogSEO title={t('title.default')} />
      <ArticlesSubHeader categories={categories} />
      <ArticlesMain posts={edges} pageContext={pageContext} locale={locale} />
      <LoadShareloWidget storyId="3SwyMK557vNxC6neTyVBL" />
    </>
  );
}

export async function getStaticProps({ preview = false, locale }) {
  let posts = { edges: [], pageInfo: { offsetPagination: { total: 0 } } };
  let categoriesData = { categories: { edges: [] } };
  if (checkLocaleAllowed(locale)) {
    try {
      posts = await getPosts(
        {
          offset: 0,
          limit: 10,
        },
        locale,
      );
      categoriesData = await getCategoriess(locale);
    } catch (error) {
      console.warn(`Failed to fetch blog data for locale ${locale}:`, error);
      // Continue with empty posts/categories
    }
  }
  const basePath = '/blog';
  const baseAsPath = `/blog`;
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common', 'blog'])),
      posts: posts || {
        edges: [],
        pageInfo: { offsetPagination: { total: 0 } },
      },
      preview,
      categories: categoriesData?.categories || { edges: [] },
      pageContext: {
        totalCount: posts?.pageInfo?.offsetPagination?.total || 0,
        limit: 10,
        skip: 0,
        filter: null,
        basePath,
        baseAsPath,
        locale,
      },
    },
    revalidate: 3600, // Regenerate page every hour
  };
}

export default Index;
